import React from "react";
import { Card, Icon, Image } from "semantic-ui-react";
import Board from './../../Drive/Tree/ActivityTreeView';
import { dispatch } from '@rematch/core';
import { withRouter } from 'react-router-dom';
import FilterActivityModal from '../../Drive/modals/FilterActivity';
import camelCase from 'lodash/camelCase';
import diamond from '../../../../../images/grafix-icon/diamond.svg'
import BreadCrumbs from './../../Drive/cards/Breadcrumbs'
import ArrangementPane from './ArrangementPane'
import EllipsisTooltip from "../../../../common/EllipsisTooltip";
import aciveFilterIcon from './../../../../../images/grafix-icon/icon-check-circle.svg';
import LoadingComponent from '../../../../common/LoadingComponent';
import ActivityCard from '../../Drive/cards/ActivityCardNew'
import _ from 'lodash';
var moment = require('moment');
let treeArray
class ActivityTreeView extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            open: false,
            loader: true
        }
    }

    async getSequenceTree(activities) {
        treeArray = activities;
        treeArray && treeArray.map((tree) => {
            if (tree.activities) {
                tree.lanes = tree.activities.length > 0 ? tree.activities.filter((activity) => { return activity.isParentNode }) : [];
                let leafNodes = tree.activities.filter((activity) => { return activity.isLeafNode })

                tree.lanes.map((lane) => {
                    lane.title = lane.name;
                    lane.start = moment().format("MMM DD, YYYY HH:mm a");
                    lane.end = moment().format("MMM DD, YYYY HH:mm a");;
                    lane.cards = lane.activities.length > 0 ? lane.activities : [];
                    lane.label = lane.cards.length > 0 ? lane.cards.length : '0';
                    lane.onTracklabel = lane.cards.length > 0 ? lane.cards.filter((i) => { return i.runStatus === 1 }).length : 0;
                    lane.cautionlabel = lane.cards.length > 0 ? lane.cards.filter((i) => { return i.isDelayedToEnd === true && i.runStatus !== 2 }).length : 0;
                    lane.issuelabel = lane.cards.length > 0 ? lane.cards.filter((i) => { return i.issueFlag === true }).length : 0;
                    lane.completedlabel = lane.cards.length > 0 ? lane.cards.filter((i) => { return i.runStatus === 2 }).length : 0;
                    lane.cards.map((card) => {
                        card.title = card.name;
                        card.start = moment().format("MMM DD, YYYY HH:mm a");
                        card.end = moment().format("MMM DD, YYYY HH:mm a");
                    })
                })

                if (leafNodes.length > 0) {
                    leafNodes.map((card) => {
                        card.title = card.name;
                        card.start = moment().format("MMM DD, YYYY HH:mm a");
                        card.end = moment().format("MMM DD, YYYY HH:mm a");
                    })

                    let lane = {
                        _id: tree._id,
                        title: "Others",
                        cards: leafNodes,
                        label: leafNodes.length,
                        onTracklabel: leafNodes.length > 0 ? leafNodes.filter((i) => { return i.runStatus === 1 }).length : 0,
                        cautionlabel: leafNodes.length > 0 ? leafNodes.filter((i) => { return i.isDelayedToEnd === true && i.runStatus !== 2 }).length : 0,
                        issuelabel: leafNodes.length > 0 ? leafNodes.filter((i) => { return i.issueFlag === true }).length : 0,
                        completedlabel: leafNodes.length > 0 ? leafNodes.filter((i) => { return i.runStatus === 2 }).length : 0,
                        isDummy: true
                    };
                    tree.lanes.push(lane)
                }
                else if (tree.lanes.length === 0) {
                    let lane = {
                        _id: tree._id,
                        title: "Others",
                        cards: [],
                        label: 0,
                        isDummy: true
                    };
                    tree.lanes.push(lane)
                }
            }
        })
        this.setState({ loader: false })
    }

    async componentDidMount() {
        dispatch.app.setRouteParams(this.props.match.params)
        let objValidation = Object.entries(this.props.selectedDataById).length === 0 && this.props.selectedDataById.constructor === Object
        if (objValidation) {
            await dispatch.initiatives.getActiveInitiativeDetailsById(this.props.match.params.initiativeId);

        }
        dispatch.initiatives.setTabName("Sequence");

        let payload = {
            organizationId: this.props.match.params.organizationId,
            initiativeId: this.props.match.params.initiativeId
        }
        await dispatch.initiatives.getPublishedContentDataAsync({ organizationId: this.props.match.params.workspaceId, category: this.props.selectedDataById.category });
        dispatch.initiatives.getAssociatedTeam(payload);
        let payload1 = {}
        payload1.organizationId = this.props.match.params.workspaceId;
        payload1.teamId = this.props.selectedDataById && this.props.selectedDataById.teamId && this.props.selectedDataById.teamId._id ?
            this.props.selectedDataById.teamId._id : this.props.selectedDataById.teamId;
        payload1.initiativeId = this.props.selectedDataById._id;
        payload1.createdBy = this.props.selectedDataById.createdBy;
        if (payload1.teamId) {
            dispatch.initiatives.getTeamDetailsOfActivity(payload1)
        }

        await this.getSequenceTree(this.props.selectedDataById.activities);
    }

    async componentWillReceiveProps(nextProps) {
        if (!_.isEqual(this.props.selectedDataById.activities, nextProps.selectedDataById.activities)) {
            await this.getSequenceTree(nextProps.selectedDataById.activities);
        }
    }

    filterClick = (open) => {
        this.setState({
            prevAdvancedFilterProperties: Object.assign({}, this.props.advancedFilterProperties),
            prevRaciFilterProperties: Object.assign({}, this.props.raciFilterProperties)
        })
        this.setState({ open: open })
    }

    closeFilterModal = () => {
        dispatch.initiatives.setAdvancedFilterProperties(Object.assign({}, this.state.prevAdvancedFilterProperties));
        dispatch.initiatives.setRACIFilterProperties(Object.assign({}, this.state.prevRaciFilterProperties));
        this.setState({ open: false })
    }


    render() {
        let windowDimension = this.props.componentDesignerDimension;


        let isFilterApplied = (this.props.raciFilterProperties &&
            (this.props.raciFilterProperties.accountable ||
                this.props.raciFilterProperties.responsible ||
                this.props.raciFilterProperties.consulted ||
                this.props.raciFilterProperties.informed)) ||
            (this.props.advancedFilterProperties &&
                (this.props.advancedFilterProperties.roles.length > 0 ||
                    this.props.advancedFilterProperties.stateActiveChecked ||
                    this.props.advancedFilterProperties.stateOnHoldChecked ||
                    this.props.advancedFilterProperties.statusNotStartedChecked ||
                    this.props.advancedFilterProperties.statusCompletedChecked ||
                    this.props.advancedFilterProperties.statusIssueChecked ||
                    this.props.advancedFilterProperties.statusInProgressChecked ||
                    this.props.advancedFilterProperties.statusDelayedChecked ||
                    this.props.advancedFilterProperties.showAllRoles ||
                    this.props.advancedFilterProperties.serarchedRolesAvailable ||
                    this.props.advancedFilterProperties.selectedUsers.length > 0)) ? true
            : false

        let height = this.props.componentDesignerDimension;
        return (
            <div
                className="containerBox overflow-hide"
                ref={this.parentRef} style={{ width: windowDimension.width ? (windowDimension.width - 40) : 300 }}>

                <ArrangementPane {...this.props} />
                <BreadCrumbs {...this.props} />
                <LoadingComponent message="Fetching Initiative Activities" active={this.state.loader} />
                <div className="initiative_overall_progress">
                    <Card className="progressDetail w_100 ">
                        <Card.Content className="header_content">
                            <Card.Header >
                                <strong className="pad_10">
                                    Sequence
                                    </strong>

                                {
                                    isFilterApplied ?
                                        <div className='pull-right pad_12 activeFilter' >
                                            <Icon link name="sliders horizontal" onClick={() => this.filterClick(true)} className="pull-right" />
                                            <Image size='mini' src={aciveFilterIcon} onClick={() => this.filterClick(true)} className="pull-right " style={{ position: "absolute", right: '8px', top: '8px', width: '10px', color: 'white' }} />
                                        </div> :
                                        <div className='pull-right pad_12' >
                                            <Icon link name="sliders horizontal" onClick={() => this.filterClick(true)} className="pull-right" />
                                        </div>
                                }

                            </Card.Header>
                        </Card.Content>
                        <Card.Content className="Detailed_content" >
                            <div id="sequenceView" className="activityTable " >
                                <div className="mainBox overflow-hide"
                                    style={{
                                        height: (height.windowHeight - height.height) - 170
                                    }} >
                                    {treeArray && treeArray.length && treeArray.map(function (tree, index) {
                                        let setWidth = tree.lanes && tree.lanes.length === 1 ?
                                            150 : tree.lanes ? tree.lanes.length * 160 : 0
                                        return (
                                            <div id={camelCase("board" + index)} className="childBox" key={index} >
                                                <div className="phaseHeading" >

                                                    <ActivityCard
                                                        type="phase"
                                                        activityData={tree}
                                                        activeTab={this.props.activeTab}
                                                        selectedActivityData={this.props.selectedActivityData}
                                                        activityRACIUsers={this.props.activityRACIUsers}
                                                        selectedDataById={this.props.selectedDataById}
                                                        selectedOrganisation={this.props.selectedOrganisation}
                                                        // index={index}
                                                        user={this.props.user}
                                                    />
                                                </div>

                                                <Board
                                                    data={tree}
                                                    boardIndex={index}
                                                    page="Sequence"
                                                    {...this.props}
                                                />
                                            </div>
                                        );
                                    }, this)}

                                </div>
                            </div>
                        </Card.Content>
                        <FilterActivityModal
                            initiativeId={this.props.match.params.initiativeId}
                            associatedTeams={this.props.associatedTeams}
                            raciFilterProperties={this.props.raciFilterProperties}
                            advancedFilterProperties={this.props.advancedFilterProperties}
                            accountUserId={this.props.user._id}
                            activeTab={this.props.activeTab}
                            open={this.state.open}
                            closeFilterModal={this.closeFilterModal}
                            filterClick={this.filterClick}
                            user={this.props.user}
                        />
                    </Card >
                </div>
            </div>


        );
    }
}

export default withRouter(ActivityTreeView);
